import constantes from '../helpers/constanteHelper'

import Form from 'react-bootstrap/Form'

function FiltrosEmpresasRedutor({ aplicarFiltros, resolucaoMobile }) {
    return (
        <Form noValidate id='form-cadastro'>
            <Form.Group style={{ width: '300px' }} className='mb-5' controlId='nome'>
                <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO }} className='fw-bold'>Nome da empresa</Form.Label>
                <Form.Control
                    type='text'
                    name='nome'
                    placeholder='Nome da empresa'
                    onChange={(e) => { aplicarFiltros(e.target.value) }}
                    required
                    maxLength={300}
                />
            </Form.Group>
        </Form>
    );
}
export default FiltrosEmpresasRedutor;
